
import React         from 'react';
import CSSModules    from 'react-css-modules';
import { reduxForm } from 'redux-form';

import { GoogleMapLoader, GoogleMap, Marker } from 'react-google-maps';

import venueRepository  from '../../services/venues';
import formInitialiser  from '../../services/formInitialiser';
import FormSubmitter    from '../../services/formSubmitter';

import * as venueListActions from '../../actions/venueList';

import Button        from '../Button';
import Input         from '../Input';
import InputGroup    from '../InputGroup';
import Label         from '../Label';
import InlineError   from '../InlineError';
import FontIcon      from '../FontIcon';

import style from './style.scss';

class VenueForm extends React.Component {

    _mapClicked(event) {

        this.props.markerLocationChanged({
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
        });
    }

    _getMapElement() {

        return (
            <GoogleMap onClick={ this._mapClicked.bind(this) } { ...this.props.mapSettings }>
                <Marker { ...this.props.markerSettings } />
            </GoogleMap>
        );
    }

    _getMapContainer() {

        return <div className={ style['map'] }></div>
    }

    render() {

        const {
            fields: {
                address: {
                    address_1,
                    address_2,
                    town_city,
                    post_code,
                    latitude,
                    longitude
                }
            },
            handleSubmit,
            submitting,
            submitSuccess
        } = this.props;

        const markerPosition = this.props.markerSettings.position;

        const createVenue = (venue) => {

            if (markerPosition) {

                venue.address.latitude  = markerPosition.lat;
                venue.address.longitude = markerPosition.lng;
            }

            return venueRepository.create(venue);
        };

        const updateVenue = (venue) => {

            if (markerPosition) {

                venue.address.latitude  = markerPosition.lat;
                venue.address.longitude = markerPosition.lng;
            }

            return venueRepository.update(venue);
        };

        var formSubmitter = new FormSubmitter({
            create: createVenue,
            update: updateVenue,
            submitSuccess
        });

        const component = this;
        
        const address = {
            address_1: address_1.value,
            town_city: town_city.value,
            post_code: post_code.value
        };

        return (

            <form onSubmit={ handleSubmit(formSubmitter.getSubmit(this.props.mode)) }>

                <div styleName="new-venue-panel">

                    <GoogleMapLoader containerElement={ component._getMapContainer() }
                                     googleMapElement={ component._getMapElement() } />

                    <div styleName="address-form">

                        <InputGroup>
                            <Label>Address 1</Label>
                            <Input { ...address_1 } errors={ address_1.error } />
                            <InlineError errors={ address_1.error } />
                        </InputGroup>

                        <InputGroup>
                            <Label>Address 2</Label>
                            <Input { ...address_2 } errors={ address_2.error } />
                            <InlineError errors={ address_2.error } />
                        </InputGroup>

                        <InputGroup>
                            <Label>Town/City</Label>
                            <Input { ...town_city } errors={ town_city.error } />
                            <InlineError errors={ town_city.error } />
                        </InputGroup>

                        <InputGroup>
                            <Label>Postcode</Label>
                            <Input { ...post_code } errors={ post_code.error } />
                            <InlineError errors={ post_code.error } />
                        </InputGroup>

                        <Button onClick={ this.props.resolveAddressLocation.bind(this, address) }
                                styleName="locate-marker-button"
                                type="button">

                            <FontIcon iconName="crosshairs"
                                      isButtonIcon={ true }
                                      textPosition="right" />

                            Locate marker
                        </Button>

                    </div>

                </div>

                <div styleName="button-panel">

                    <Button onClick={ this.props.cancel }
                            styleName="action-button"
                            theme="secondary"
                            type="button">

                        <span>Cancel</span>

                    </Button>

                    <Button disabled={ submitting }
                            styleName="action-button"
                            type="submit"
                            theme="success">

                        <span>Save</span>

                    </Button>

                </div>

            </form>
        );
    }
}

const reduxFormParams = {
    form: 'venue',
    fields: [
        'id',
        'address.address_1',
        'address.address_2',
        'address.town_city',
        'address.post_code',
        'address.latitude',
        'address.longitude'
    ]
};

function mapStateToProps(state) {

    const {
        formMode,
        defaultForm,
        venueToEdit,
        mapSettings,
        markerSettings
    } = state.venueList;

    return {
        initialValues: formInitialiser.getInitialValues(formMode, defaultForm, venueToEdit),
        mode: formMode,
        mapSettings,
        markerSettings
    };
}

function mapDispatchToProps(dispatch) {

    return {
        markerLocationChanged: (location) => {

            dispatch(venueListActions.venueLocationResolved(location));
        },
        resolveAddressLocation: (address) => {
            
            dispatch(venueListActions.resolveAddressLocation(address));
        }
    };
}

export default reduxForm(reduxFormParams, mapStateToProps, mapDispatchToProps)(CSSModules(VenueForm, style));


// WEBPACK FOOTER //
// ./components/VenueForm/index.js